'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var routerAdapter = require('@piconetworks/router-adapter');
var Image = require('@piconetworks/image');
var heading = require('@piconetworks/heading');
var text = require('@piconetworks/text');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Image__default = /*#__PURE__*/_interopDefaultLegacy(Image);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var style = {"linkContainer":"VerifyEmail-module_linkContainer__2fRfM","button":"VerifyEmail-module_button__1BUZ8","avatar":"VerifyEmail-module_avatar__1sLdT"};

var VerifyEmail = /*#__PURE__*/function (_React$Component) {
  _inherits(VerifyEmail, _React$Component);

  var _super = _createSuper(VerifyEmail);

  function VerifyEmail() {
    var _this;

    _classCallCheck(this, VerifyEmail);

    _this = _super.call(this);
    _this.state = {
      requestLoginLinkSent: false
    };
    return _this;
  }

  _createClass(VerifyEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          accessToken = _this$props.accessToken,
          publisherId = _this$props.publisherId,
          userEmail = _this$props.userEmail,
          hasUserLoader = _this$props.hasUserLoader,
          userVerified = _this$props.userVerified,
          redirectUrl = _this$props.redirectUrl,
          requestLoginLink = _this$props.requestLoginLink;

      if (!accessToken || !hasUserLoader || userVerified) {
        return;
      }

      this.setState({
        requestLoginLinkSent: true
      });
      requestLoginLink({
        email: userEmail,
        redirectUrl: redirectUrl,
        publisherId: publisherId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var requestLoginLinkSent = this.state.requestLoginLinkSent;
      var publisherName = this.props.publisherName;

      if (!requestLoginLinkSent) {
        return null;
      }

      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: style.linkContainer
      }, /*#__PURE__*/React__default['default'].createElement(Image__default['default'].Avatar, {
        className: style.avatar,
        src: "https://widget.staging.pico.tools/img/magic-link.svg"
      }), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "content"
      }, /*#__PURE__*/React__default['default'].createElement(heading.H3, null, "You've got mail."), /*#__PURE__*/React__default['default'].createElement(text.P, null, "Check your inbox for a magic link from", ' ', publisherName, ' ', "that will take you right back to our site. If you prefer to log in with a password,", ' ', "look for an additional link in the email to create a password for your account.")));
    }
  }]);

  return VerifyEmail;
}(React__default['default'].Component);

VerifyEmail.defaultProps = {
  accessToken: null,
  publisherId: null
};
VerifyEmail.propTypes = {
  accessToken: PropTypes__default['default'].string,
  hasUserLoader: PropTypes__default['default'].bool.isRequired,
  publisherId: PropTypes__default['default'].string,
  publisherName: PropTypes__default['default'].string.isRequired,
  redirectUrl: PropTypes__default['default'].string.isRequired,
  requestLoginLink: PropTypes__default['default'].func.isRequired,
  userEmail: PropTypes__default['default'].string.isRequired,
  userVerified: PropTypes__default['default'].bool.isRequired
};
var index = routerAdapter.withRouter(VerifyEmail);

module.exports = index;
